import { Injectable } from '@angular/core';

import { IntegrationLog } from '../../models/troly/integration_log.model';
import { ITrolyService, TrolyService } from './troly.service';

@Injectable({
    providedIn: 'root',
})
export class IntegrationLogService extends TrolyService<IntegrationLog> implements ITrolyService<IntegrationLog> {

	/**
	 * The name or identifier of the current class, not otherwise available when running in "production mode". 
	 * It is used to output debugging information on the console, and also attached to translations of labels, product tours, etc
	 */
	public readonly __name:string = 'IntegrationLogService';

	constructor() { super('logs', 'integration_logs'); }

	public make(payload: {} = {}): IntegrationLog { return payload instanceof IntegrationLog ? payload : new IntegrationLog(payload); }
}
